import {
  EnvironmentNetworkInfo,
  EnvironmentServiceGetNetworkInfoResponse,
} from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/environment_pb";
import { NetworkMemberType } from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/network_pb";

export const environmentNetworkInfoKeys = {
  all: ["environment-network-info"] as const,
  detail: (environmentId: string) =>
    [...environmentNetworkInfoKeys.all, environmentId] as const,
};

export const getEnvironmentNetworkInfoQueryKey = (environmentId: string) =>
  environmentNetworkInfoKeys.detail(environmentId);

export function withNetworkMemberType(
  response: EnvironmentServiceGetNetworkInfoResponse | undefined,
  memberType: NetworkMemberType,
): EnvironmentServiceGetNetworkInfoResponse | undefined {
  if (!response?.networkInfo) return response;

  return new EnvironmentServiceGetNetworkInfoResponse({
    ...response,
    networkInfo: new EnvironmentNetworkInfo({
      ...response.networkInfo,
      networkMemberType: memberType,
    }),
  });
}
